import { Col, Popconfirm, Row, Space, Spin, Table, Tag, Typography } from "antd"
import React, { useEffect, useState } from "react"
import PageHeader from "../../components/Elements/PageHeader"
import { BankFilled, CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons"
import { db } from "../../firebase/config"
import { collection, onSnapshot } from "firebase/firestore"
import { handleStockChange, deleteMaterial } from "./Functions/SMaterialFunctions"
import CreateSMaterial from "./CreateSMaterial"

const { Link } = Typography

export default function SMaterials() {
  const [tableLoading, setTableLoading] = useState(true)
  const [materialsData, setMaterialsData] = useState([])

  //loads table data from database
  useEffect(() => {
    setTableLoading(true)
    const matRef = collection(db, "secondWarehouse")
    const unsubscribe = onSnapshot(matRef, (snapshot) => {
      let results = []
      snapshot.docs.forEach((doc) => {
        const rollsArray = Object.values(doc.data().rolls) // roll count
        const widthsArray = rollsArray.map((roll) => roll.rollWidth) // creates array of widths
        const totalRollMeters = rollsArray.reduce((total, roll) => total + roll.remainingMeters, 0) // calculate total roll meters
        const docData = {
          ...doc.data(),
          id: doc.id,
          rollsCount: rollsArray.length,
          widthsArray,
          totalRollMeters,
        }
        results.push(docData)
      })
      setMaterialsData(results)
      setTableLoading(false)
    })
    return () => unsubscribe()
  }, [])

  //default columns for table
  const defaultColumns = [
    {
      title: "Stock",
      dataIndex: "stock",
      align: "center",
      width: "6%",
      render: (text, value, index) =>
        text === true ? (
          <CheckCircleOutlined
            style={{ color: "#1677ff" }}
            onClick={() => handleStockChange(value)}
          />
        ) : (
          <CloseCircleOutlined
            style={{ color: "#f5222d" }}
            onClick={() => handleStockChange(value)}
          />
        ),
    },
    {
      title: "Material",
      dataIndex: "material",
      align: "center",
      width: "15%",
    },
    {
      title: "Meters",
      dataIndex: "totalRollMeters",
      align: "center",
      width: "15%",
    },
    {
      title: "Eur m2",
      dataIndex: "eurM2",
      align: "center",
      width: "7%",
    },

    {
      title: "gM2",
      dataIndex: "gM2",
      align: "center",
      width: "7%",
      sorter: {
        compare: (a, b) => a.gM2 - b.gM2,
      },
    },
    {
      title: "Comment",
      dataIndex: "comment",
      align: "center",
      width: "15%",
    },

    {
      title: "Rolls (pcs)",
      dataIndex: "rollsCount",
      align: "center",
      width: "5%",
    },
    {
      title: "Widths",
      dataIndex: "widthsArray",
      align: "center",
      key: "widths",
      width: "25%",
      render: (widthsArray) => (
        <>
          {widthsArray &&
            widthsArray.map((width, i) => (
              <Tag color="blue" key={i}>
                {width}
              </Tag>
            ))}
        </>
      ),
    },

    {
      title: "Action",
      align: "center",
      width: "10%",
      render: (value) => (
        <>
          <Space split>
            <Popconfirm
              title="Are you sure？"
              placement="left"
              onConfirm={(event) => deleteMaterial(event, value.id)}
              okText="Yes"
              cancelText="No">
              <Link style={{ color: "red" }}>delete</Link>
            </Popconfirm>
          </Space>
        </>
      ),
    },
  ]

  if (tableLoading) {
    return (
      <>
        <Spin />
      </>
    )
  }

  return (
    <div style={{ padding: 15 }}>
      <Row>
        <Col span={24}>
          <PageHeader icon={<BankFilled />} text="S Warehouse Materials" />
        </Col>
        <Col span={24}>
          <CreateSMaterial />
        </Col>
        <Col span={24}>
          <Table
            style={{ marginTop: "15px" }}
            size="small"
            dataSource={materialsData}
            loading={tableLoading}
            columns={defaultColumns}
            bordered
            pagination={{ defaultPageSize: "8", showSizeChanger: true }}
          />
        </Col>
      </Row>
    </div>
  )
}
